module.exports = __webpack_public_path__ + "img/ape-constructor-wallet.7d220f02.svg";